import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import BookmarksContent from '../../components/Pages/Bookmarks';

const { displayName } = config;

export default function Bookmarks(): React.ReactNode | null {
  document.title = `${displayName}: Bookmarks`;

  return (
    <Layout>
      <BookmarksContent />
    </Layout>
  );
}
